import {useEffect, useState} from "react";

export const useTimer = ({expire, onComplete}) => {
    const [timeToLive, setTimeToLive] = useState(0);

    useEffect (() => {
        if (expire === null) {
            setTimeToLive(0);
            return () => {};
        }

        const cartInterval = setInterval(() => {
            const now = new Date();
            // check to see if the interval is expired
            if (now > expire) {
                clearInterval(cartInterval);

                if (onComplete) onComplete();

            } else {
                // update the time to live for rendering
                const secondsLeft = Math.floor((expire - now) / 1000);
                console.log(`${expire} ${now} ${expire-now} ${secondsLeft} seconds left`);
                setTimeToLive(secondsLeft);
            }
        }, 1000)

        return () => {
            console.log(`clearing cart interval`);
            clearInterval(cartInterval);
        }
    }, [expire, onComplete])

    return timeToLive;
}